import Controller from "../Engine/Controller";
import cfJS from "../Engine/cfJS";

/*
* Create Tab Content
*
* list
* dynamic
*/
class Tab extends Controller{

    constructor (dom) {
        super(dom, "Tab");

        this.domNode.className = "Tab";

        this.TabListeners = [];
        this._connectHandlers();
        this._options = {};

        //init this tab js-events
        let ActiveTab = cfJS.querySelector(this.domNode, ">.TabSectionContainer>.TabSection[selected]");
        let activeId = Number(ActiveTab.getAttribute("tab_container"));
        if (window["client_tab_widget_listener_open_tab_"+(activeId)]) {
            window["client_tab_widget_listener_open_tab_"+(activeId)]();
        }
    }
    /*
    * set options to tab element
    *
    * [
    *   dynamic - dunamic upload pages
    * ]
    */
    options (options) {
        this._options = options;
    }

    _connectHandlers () {
        let that = this;
        let TabHeads = cfJS.querySelectorAll(this.domNode,">.TabSectionContainer>.TabSection");

        function _clickOnTab(event, num, href) {
            if (!that._options.dynamic) {
                that.OpenTab(num+1);

                //set cashe to seleted tab
                if (that._options["auto_uri_select"])
                    cfJS.insetUriGetParam("tabselected",num+1);
            }
            else
                location.href = href;

            //event to use some js from page
            if (window["client_tab_widget_listener_open_tab_"+(num+1)]) {
                window["client_tab_widget_listener_open_tab_"+(num+1)]();
            }
        }

        for (let i=0; i<TabHeads.length; i++)
            this.TabListeners[i] = cfJS.addListener(TabHeads[i], "click", function (e) {
                _clickOnTab(e,i, TabHeads[i].getAttribute("href"));
            });
    }

    OpenTab (id) {
        let ActiveTab = cfJS.querySelector(this.domNode, ">.TabSectionContainer>.TabSection[selected]");

        if (id!=ActiveTab.getAttribute("tab_container")) {
            let activeId = Number(ActiveTab.getAttribute("tab_container"));
            ActiveTab.removeAttribute("selected");

            cfJS.querySelector(this.domNode, ">.TabContainer[tab_container='"+activeId+"']").removeAttribute("selected");
            cfJS.querySelector(this.domNode, ">.TabContainer[tab_container='"+id+"']").setAttribute("selected",true);
            cfJS.querySelector(this.domNode, ">.TabSectionContainer>.TabSection[tab_container='"+id+"']").setAttribute("selected",true);
        }
    }
}

window.Tab = Tab;